import { EntitiesState } from '@redux/entities'

import type { SelectedOption } from '@functions/selectPriceListItemOptionValue'
import type { CampaignQuoteTemplateItemModel } from '@models/types'

type BuildStandardOrderParams = {
  agencyId?: number,
  campaignId?: number,
  campaignProposalId?: number,
  campaignQuoteId?: number,
  campaignQuoteTemplateId?: number,
  existingOrderId?: number,
  isDefaultQuoteItem?: boolean,
  quoteSectionId?: number,
  redirect?: string,
  selectedProviderPriceListItemId?: number,
  selectedProviderPriceListItemOptions: SelectedOption[],
  selectedServiceProductId?: number,
  selectedTags: string[],
  serviceProducts: EntitiesState['serviceProducts'],
}

const buildStandardOrder = (params: BuildStandardOrderParams) => {
  const {
    agencyId,
    campaignId,
    campaignProposalId,
    campaignQuoteId,
    campaignQuoteTemplateId,
    existingOrderId,
    isDefaultQuoteItem,
    quoteSectionId,
    redirect,
    selectedProviderPriceListItemId,
    selectedProviderPriceListItemOptions,
    selectedServiceProductId,
    selectedTags,
    serviceProducts,
  } = params

  const options = {
    campaignId,
    campaignProposalId,
    campaignQuoteId,
    campaignQuoteTemplateId,
    existingOrderId,
    quoteSectionId,
    redirect,
  }

  const selectedServiceProduct = selectedServiceProductId && serviceProducts[selectedServiceProductId]
    ? serviceProducts[selectedServiceProductId]
    : {}

  // Quote Item
  if (campaignQuoteId || campaignQuoteTemplateId){
    const payload: Partial<CampaignQuoteTemplateItemModel> = {
      // @ts-expect-error TS2353
      campaign_quote_id: undefined,
      campaign_quote_section_id: undefined,
      campaign_quote_template_id: undefined,
      campaign_quote_template_section_id: undefined,
      data: {
        tags: selectedTags,
      }, 
      item_type: 'orderable',
      options: selectedProviderPriceListItemOptions,
      price_list_item_id: selectedProviderPriceListItemId,
      // @ts-expect-error TS2339
      title: selectedServiceProduct.title || 'Quote Item',
    }

    // Quote
    if (campaignQuoteId){
      // @ts-expect-error TS2339
      payload.campaign_quote_id = campaignQuoteId
      // @ts-expect-error TS2339
      payload.campaign_quote_section_id = quoteSectionId
    }

    // Quote Template
    if (campaignQuoteTemplateId){
      payload.campaign_quote_template_id = campaignQuoteTemplateId
      payload.campaign_quote_template_section_id = quoteSectionId
    }

    return {
      itemType: campaignQuoteTemplateId ? 'quoteTemplateItem' : 'quoteItem',
      options,
      payload,
      redirect,
    }
  }

  if (isDefaultQuoteItem){
    return {
      itemType: 'defaultQuoteItem',
      options,
      payload: {
        data: {
          tags: selectedTags,
        },
        item_type: 'orderable',
        options: selectedProviderPriceListItemOptions,
        owner_id: agencyId,
        owner_type: 'Agency',
        price_list_item_id: selectedProviderPriceListItemId,
        // @ts-expect-error TS2339
        title: selectedServiceProduct.title || 'Default Quote Item',
      },
      redirect,
    }
  }
  
  return {
    itemType: 'order',
    options,
    payload: {
      campaign_id: campaignId,
      campaign_proposal_id: campaignProposalId || null,
      order_type: campaignProposalId ? 'proposal' : 'item',
      items: JSON.stringify([{
        price_list_item_id: selectedProviderPriceListItemId,
        options: selectedProviderPriceListItemOptions,
        data: {
          tags: selectedTags,
        },
      }]),
    },
    redirect,
  }
}

export type BuildStandardOrderPayload = ReturnType<typeof buildStandardOrder>

export default buildStandardOrder
